import { LinkIcon } from '@chakra-ui/icons'
import { Button, HStack, Input, Spinner, Stack, Text, VStack } from '@chakra-ui/react'
import { usePopUpMessage } from '@hb/react'
import { colors, LinkClaimArgs, PregnancyClaim } from '@hb/shared'
import { useCallback, useState } from 'react'
import { linkClaim } from '../../../../../backend/functions/claims'
import { InovalonButton } from './InovalonButton'

// provide assessment id for new claim, claim ID for existing claim
export const LinkAbilityClaim = ({
  claimId,
  assessmentId,
  claim,
  isRelink,
  alwaysOpen,
  onCancel,
  onComplete,
}: {
  claimId: string | null
  assessmentId: string | null
  claim?: PregnancyClaim
  onCancel?: () => void
  alwaysOpen?: boolean
  onComplete?: () => void
  isRelink?: boolean
}) => {
  const [id, setId] = useState('')
  const [loading, setLoading] = useState(false)
  const [linking, setLinking] = useState(!!alwaysOpen)
  const { showSuccess, showError } = usePopUpMessage()

  const onSubmit = useCallback(() => {
    if (!claimId && !assessmentId) {
      showError('no claim or assessment ID provided')
      return
    }
    if (claimId && assessmentId) {
      showError('both claim and assessment ID provided')
      return
    }
    if (!id) {
      showError("Enter the claim ID from ability's system")
      return
    }
    setLoading(true)
    return linkClaim({ dbId: claimId, abilityId: id, assessmentId } as LinkClaimArgs)
      .then(() => {
        setLoading(false)
        if (onComplete) onComplete()
        showSuccess('Linked!')
      })
      .catch((err: any) => {
        setLoading(false)
        console.error(err)
        showError(
          err.message === 'Not found' ? "Couldn't find that Inovalon claim" : 'Internal error',
        )
      })
  }, [id, claimId, showError, showSuccess, onComplete, assessmentId])
  // if (claim?.submittedToAbility) {
  //   return (
  //     <HStack p={2}>
  //       <Spinner color={colors.green.hex} />
  //       <Text>Claim is being validated by Inovalon</Text>
  //     </HStack>
  //   )
  // }
  return (
    <VStack spacing={1} align="flex-start" w="100%">
      {claim?.submittedToAbility ? (
        <HStack bg="whiteAlpha.700" borderRadius={3} p={2}>
          <Spinner color={colors.green.hex} />
          <Text>Claim is being validated by Inovalon</Text>
        </HStack>
      ) : null}
      <Text fontWeight={600} fontSize="sm" color="gray.500">
        {isRelink ? 'RE-LINK TO ABILITY' : 'LINK TO ABILITY'}
      </Text>
      <Stack width={isRelink ? 'auto' : '100%'} direction="row">
        <InovalonButton
          disabled={loading}
          onClick={() => {
            if (isRelink) {
              if (onCancel) onCancel()
            } else setLinking(!linking)
          }}
          color="white"
          px={isRelink ? 2 : 4}
          fontSize="sm"
          size="sm">
          {linking || isRelink ? (
            'CANCEL'
          ) : (
            <>
              <LinkIcon
                filter="drop-shadow(1px 1px 2px #555)"
                position="relative"
                bottom="2px"
                mr={isRelink ? 0 : 2}
              />
              {isRelink ? null : 'LINK CLAIM TO INOVALON'}
            </>
          )}
        </InovalonButton>
        <Stack
          flex={1}
          direction="row"
          opacity={isRelink || linking ? 1 : 0}
          pointerEvents={isRelink || linking ? 'auto' : 'none'}>
          <Input
            disabled={(!linking && !isRelink) || loading}
            placeholder="Inovalon claim ID"
            size="sm"
            variant="outline"
            value={id}
            onChange={({ target: { value } }) => setId(value)}
          />
          <Button
            onClick={onSubmit}
            isLoading={loading}
            px={4}
            fontSize="sm"
            size="sm"
            bg="#afbd20"
            color="white">
            {isRelink || claim?.submittedToAbility ? 'RE-LINK' : 'LINK'}
          </Button>
        </Stack>
      </Stack>
    </VStack>
  )
}
